import WidgetClientDamageIncidents from './widget-damage-incidents';
import NewDamageIncidentForm from './new-damage-incident-form';
import ClientDamageIncidents from './client-damage-incidents';
import ClientCustomDetails from './client-custom-details';
import ClientInteractions from './client-interactions';
import ClientRooftopView from './client-rooftop-view';
import ClientPermissions from './client-permissions';
import InteractionsList from './interactions-list';
import ClientContainer from './client-container';
import ClientContacts from './client-contacts';
import ClientIncident from './client-incident';
import ClientTaskList from './client-task-list';
import ClientNewTask from './client-new-task';
import ClientFormNew from './client-form';
import ClientDetails from './client-details';
import ClientModify from './client-modify';
import ClientNewLead from './client-new-lead';
import ClientSelect from './client-select';
import ClientTasks from './client-tasks';
import ClientView from './client-view';
import ClientJobs from './client-jobs';
import ClientCreate from './client-create';

export {
  WidgetClientDamageIncidents,
  NewDamageIncidentForm,
  ClientDamageIncidents,
  ClientInteractions,
  ClientCustomDetails,
  ClientRooftopView,
  ClientPermissions,
  InteractionsList,
  ClientContainer,
  ClientContacts,
  ClientIncident,
  ClientTaskList,
  ClientNewTask,
  ClientDetails,
  ClientNewLead,
  ClientSelect,
  ClientModify,
  ClientTasks,
  ClientFormNew,
  ClientView,
  ClientJobs,
  ClientCreate,
}

export * from './contacts';
export * from './jobs';
export * from './incidents';



// WEBPACK FOOTER //
// ./src/browser/components/client/index.js